import { defined } from "@formant/core/common/defined";
import { IDeviceTeleopConfiguration } from "@formant/core/model/IDeviceTeleopConfiguration";
import { IRtcStream } from "@formant/core/model/IRtcStream";
import { rosTypeBool } from "@formant/core/model/rosTypes";
import { rtcBitsetStreamType } from "@formant/core/model/rtcStreamTypes";
import { TeleopMode } from "@formant/core/model/TeleopMode";

import { teleopStreamToRtc } from "./teleopStreamToRtc";

export function getBitsetsFromStreamConfig(
    deviceId: string,
    configuration: IDeviceTeleopConfiguration | undefined,
    mode: TeleopMode,
): IRtcStream[] {
    const rosStreams = configuration?.rosStreams;
    const customStreams = configuration?.customStreams;

    if (!deviceId) {
        return [];
    }

    return [
        ...(rosStreams || [])
            .filter(_ => _.topicType === rosTypeBool && _.mode === mode)
            .map(_ => teleopStreamToRtc(deviceId, _))
            .filter(_ => _ !== undefined)
            .map(_ => defined(_)),
        ...(customStreams || [])
            .filter(
                _ => _.rtcStreamType === rtcBitsetStreamType && _.mode === mode,
            )
            .reduce<IRtcStream[]>((acc, _) => {
                _.labels?.forEach(label => {
                    acc.push({
                        entityId: deviceId,
                        streamName: _.name,
                        streamType: _.rtcStreamType,
                        label,
                    });
                });
                return acc;
            }, []),
    ];
}
